import {
  Badge,
  Box,
  Heading,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFetchPaginatedBreakRules } from 'hooks/breakRules/useFetchBreakRules';

const initialSearchQuery = {
  active: true,
  page: 1,
  page_size: 10,
};

interface IProps {
  onClose: () => void;
  isOpen: boolean;
  onBreakSelect: (breakRule: any) => void;
}

const BreakRulesList: React.FC<IProps> = ({ onClose, isOpen, onBreakSelect }) => {
  const { status: breaksRulesStatus, data: breaksRulesData } = useFetchPaginatedBreakRules(initialSearchQuery);
  const { t } = useTranslation(['common']);

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Break Type</ModalHeader>
        <ModalCloseButton />
        <ModalBody p="6">
          {breaksRulesStatus === 'success' && breaksRulesData?.payload.length > 0 && (
            <List>
              {breaksRulesData?.payload.map((brk: any) => (
                <ListItem key={brk.id} onClick={() => onBreakSelect(brk)}>
                  <Box
                    padding="2"
                    marginBottom="3"
                    boxShadow="xs"
                    rounded="md"
                    bg="white"
                    _hover={{ bg: 'gray.200' }}
                    cursor="pointer"
                    display="flex"
                    justifyContent="space-between"
                  >
                    <Box>
                      <Heading as="h2" size="sm">
                        {brk?.name}
                      </Heading>
                      <Text>
                        {brk?.length / 60} {t('common:minutes')}
                        <Badge ml="1" fontSize="0.8em" colorScheme={brk.paid ? 'green' : 'orange'}>
                          {brk?.paid ? t('common:paid') : t('common:unpaid')}
                        </Badge>
                      </Text>
                    </Box>
                    {/* {(brk?.is_cali_meal_break || brk?.is_cali_rest_break) && (
                      <Badge
                        alignSelf="flex-start"
                        variant="solid"
                        bg="secondary.400"
                        color="white"
                        px="2"
                        py="0.5"
                        fontWeight="small"
                        textTransform="uppercase"
                        borderRadius="8px"
                      >
                        {brk?.is_cali_meal_break ? t('common:caliMealBreak') : t('common:caliRestBreak')}
                      </Badge>
                    )} */}
                  </Box>
                </ListItem>
              ))}
            </List>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default BreakRulesList;
